import React, {lazy, useEffect} from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect,useHistory } from 'react-router-dom'
import AccessibleNavigationAnnouncer from './components/AccessibleNavigationAnnouncer'
import {useDispatch, useSelector} from "react-redux";
import {fetchUser} from "./redux/actions/login";
import  "./utils/i18n/i18n";


const Layout = lazy(() => import('./containers/Layout'))
const Login = lazy(() => import('./pages/Login'))
const CreateAccount = lazy(() => import('./pages/CreateAccount'))
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'))
const Home = lazy(() => import('./pages/Home'))

function App() {
  const login = useSelector( u => u.login);
  const dispatch = useDispatch();

  useEffect(()=> {
          dispatch(fetchUser())

  },[]);

    const { innerWidth: width, innerHeight: height } = window;
  return (
    <>
      <Router>

        <AccessibleNavigationAnnouncer />

          {width  < 700 ?
              //// mobilse
              login.isAuthenticated ?

                  <Switch>
                      <Route path="/app" component={Layout}/>
                      <Redirect from="/" to="/app"/>
                  </Switch>  :
                  <Switch>
                      <Redirect exact from="/" to="/login"/>
                      <Route path="/login"  component={Login}/>
                      <Route path="/create-account" component={CreateAccount}/>
                      <Route path="/forgot-password" component={ForgotPassword}/>
                      <Route render={() => <Redirect to="/" />} />
                  </Switch>

               :
              /// mobil değilse
              login.isAuthenticated ?

                  <Switch>
                      <Route path="/app" component={Layout}/>
                      <Redirect from="/" to="/app"/>
                  </Switch>  :
                  <Switch>
                      <Route path="/login"  component={Login}/>
                      <Route path="/home"  component={Home}/>
                      <Route path="/create-account" component={CreateAccount}/>
                      <Route path="/forgot-password" component={ForgotPassword}/>
                      <Route render={() => <Redirect to="/home" />} />

                  </Switch>
          }


      </Router>
    </>
  )
}

export default App
